import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Subscription, map, merge } from 'rxjs';

import { TaTranslationService } from '@ta/translation';

@Injectable({ providedIn: 'root' })
export class TranslatedTitleStrategy extends TitleStrategy {
  private _title = inject(Title);
  private _translate = inject(TaTranslationService);
  private _current?: Subscription;

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const titleKey = this.buildTitle(snapshot);
    if (!titleKey) {
      return;
    }

    // `stream()` ne réagit qu'au changement de langue ; les fichiers arrivent par `reloadLang()`,
    // qui n'émet que `onTranslationChange`. Sur une route sans garde, le titre est calculé avant
    // eux : on ignore la clé brute et on retraduit à leur arrivée.
    this._current?.unsubscribe();
    this._current = merge(
      this._translate.stream(titleKey),
      this._translate.onTranslationChange$.pipe(map(() => this._translate.instant(titleKey))),
    ).subscribe((translated: string) => {
      if (translated && translated !== titleKey) {
        this._title.setTitle(`Bailo - ${translated}`);
      }
    });
  }
}
